import React, { useEffect, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, AlertTriangle } from 'lucide-react';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';

function PageNotFound() {
    const isUserLoggedIn = useMemo(() => {
        try {
            const user = localStorage.getItem('user');
            return user && user !== "" && user !== "null" && user !== "{}";
        } catch {
            return false;
        }
    }, []);

    useEffect(() => {
        document.title = 'Page Not Found';
    }, []);

    const isRxTheme = useMemo(() => {
        const domain = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        return domain === "rxhacker.com" || 
               domain === "localhost:5464" || 
               window.location.host.toLowerCase() === "tempfilter.23byt.es" || 
               window.location.host.toLowerCase() === "reporting.nulifespanrx.com";
    }, []);

    const content = (
        <div className="flex items-center justify-center min-h-[60vh]">
            <Card className="w-full max-w-md shadow-lg border">
                <CardContent className="p-8 text-center">
                    {/* Error Icon */}
                    <div className="flex justify-center mb-6">
                        <div className={`w-20 h-20 rounded-full flex items-center justify-center ${
                            isRxTheme ? 'bg-primary/10' : 'bg-amber-100'
                        }`}>
                            <AlertTriangle className={`w-10 h-10 ${
                                isRxTheme ? 'text-primary' : 'text-amber-600'
                            }`} />
                        </div>
                    </div>

                    {/* Error Message */}
                    <h1 className="text-4xl font-bold text-foreground mb-2">404</h1>
                    <h2 className="text-xl font-semibold text-foreground mb-4">Page Not Found</h2>
                    <p className="text-muted-foreground mb-8">
                        We can't find the page you're looking for.
                    </p>

                    {/* Home Button */}
                    <NavLink to="/dashboard">
                        <Button className="font-semibold bg-primary hover:bg-primary/90 text-primary-foreground">
                            <Home className="mr-2 h-4 w-4" />
                            Take me Home
                        </Button>
                    </NavLink>
                </CardContent>
            </Card>
        </div>
    );

    // If user is logged in, show with sidebar layout
    if (isUserLoggedIn) {
        return (
            <PagesWrapper>
                {content}
            </PagesWrapper>
        );
    }

    // If not logged in, show simple centered layout
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            {content}
        </div>
    );
}

export default PageNotFound;

